import React from "react";
import { assetUrl } from "../../../utils/assets";

interface ConsultationReminderModalProps {
  visible: boolean;
  onClose: () => void;
}

const ConsultationReminderModal: React.FC<ConsultationReminderModalProps> = ({
  visible,
  onClose,
}) => {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-end justify-center bg-black bg-opacity-40">
      <div className="w-full max-w-md p-6 bg-white rounded-t-2xl shadow-lg">
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="text-gray-500 text-xl focus:outline-none"
            aria-label="Tutup"
          >
            ✕
          </button>
        </div>
        <div className="flex flex-col items-center mt-4 text-center">
          <img
            src={assetUrl("images/hourglass.png")}
            alt="Jam Pasir"
            className="w-20 h-20 mb-4"
          />
          <h2 className="text-lg font-semibold mb-2">
            Waktu Konsultasi Tinggal 5 Menit
          </h2>
          <p className="text-sm text-gray-600 mb-6">
            Silakan selesaikan diskusi dengan dokter dan pastikan semua kebutuhan,
            termasuk resep dan rujukan, sudah terpenuhi.
          </p>
          <button
            onClick={onClose}
            className="bg-red-500 text-white font-semibold px-6 py-2 rounded-full focus:outline-none w-full"
          >
            Oke
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsultationReminderModal;
